import { create } from 'zustand';

export const initialSubscriptionPaymentState = {
  planAmountCtx: 0,
  planIdCtx: 0,
  sessionIdCtx: '',
  sessionTimestampCtx: '',
  pgNameCtx: '',
  paymentConfigDataCtx: [] as any[],
  instrumentTypeCtx: '',
  upiLogosCtx: [] as any[],
  scannerTextCtx: 'Scan to add',
  messageDataCtx: 'Scan and pay with any UPI app',
  sharedDataCtx: {
    ctaText: 'Share QR',
    message: '',
    title: '',
  } as {
    ctaText: string;
    message: string;
    title?: string;
  },
  subscriptionStatusCtx: [
    {
      id: 1,
      name: 'Trail',
      isEnabled: true,
    },
    {
      id: 2,
      name: 'Paid',
      isEnabled: false,
    },
  ],
  orderIdCtx: '',
  orderTimestampCtx: '',
  orderPgNameCtx: '',
  orderMandateFlowDataCtx: '',
  errorMessageCtx: [] as any[],
  // QR status polling interval for QR Code flow (in ms)
  qrPollingConfigCtx: 15000,
  subtypewidgetUpiCtx:''
};

export type SubscriptionPaymentData = typeof initialSubscriptionPaymentState;

export type SubscriptionPaymentStore = {
  subscriptionPaymentDataCtx: SubscriptionPaymentData;
  setSubscriptionPaymentDataCtx: (
    updater: (prev: SubscriptionPaymentData) => SubscriptionPaymentData,
  ) => void;
  resetSubscriptionPaymentDataCtx: () => void;
};

export const useSubscriptionPaymentStore = create<SubscriptionPaymentStore>((set) => ({
  subscriptionPaymentDataCtx: initialSubscriptionPaymentState,
  setSubscriptionPaymentDataCtx: (updater) =>
    set((state) => ({
      subscriptionPaymentDataCtx: updater(state.subscriptionPaymentDataCtx),
    })),
  resetSubscriptionPaymentDataCtx: () => set({ subscriptionPaymentDataCtx: initialSubscriptionPaymentState }),
}));


